var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6311 0H22.5842V3.91875H26.228V0H30.1811V11.8594H26.228V7.90625H22.6186V11.8594H18.6311V0ZM35.4061 3.95312H31.917V0H42.8655V3.95312H39.3592V11.8594H35.4061V3.95312ZM44.6014 0H48.7436L51.2873 4.17656L53.8311 0H57.9733V11.8594H54.0202V5.98125L51.253 10.2437L48.4858 5.98125V11.8594H44.6014V0ZM59.9327 0H63.8858V7.94063H69.4889V11.8594H59.9327",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4939 80.9531L12.822 17.2906H75.1783L69.5064 80.9187L43.9486 88",
    fill: "#E44D26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82.5859V22.5156H69.4891L64.625 76.8281",
    fill: "#F16529"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4062 30.3017H44V38.1048H32.9656L33.6875 46.097H44V53.8829H26.5375L24.4062 30.3017ZM26.8812 57.8017H34.7188L35.2687 64.0407L44 66.3782V74.5251L27.9813 70.0564",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5251 30.3017H43.9657V38.1048H62.8032L63.5251 30.3017ZM62.0985 46.097H43.9657V53.9001H53.5907L52.6798 64.0407L43.9657 66.3782V74.4907L59.9501 70.0564",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.fe3978ce182944c5c968710c6563eae6.svg";
export { ForwardRef as ReactComponent };